export default __webpack_public_path__ + "static/media/hekma2.ba576936.png";